import { createFileRoute } from "@tanstack/react-router";

import { ResearchPage } from "../../../workspaces/training/pages/ResearchPage";

export const Route = createFileRoute("/_console/p/$org/$project/training/research/")({
  component: ResearchPage,
});
